export const MENU_ACCESS_GROUPS = [
  { label: 'Event Management', items: [
    { key: 'events.events', label: 'Events' }, { key: 'events.maps', label: 'Maps' },
    { key: 'events.exhibitors', label: 'Exhibitors' }, { key: 'events.products', label: 'Products' },
    { key: 'events.orders', label: 'Orders' },
  ] },
  { label: 'Magazine', items: [
    { key: 'magazine.publications', label: 'Publications' }, { key: 'magazine.issues', label: 'Issues' },
    { key: 'magazine.inventory', label: 'Inventory' }, { key: 'magazine.proposals', label: 'Proposals' },
    { key: 'magazine.reports', label: 'Issue report' }, { key: 'magazine.contracts', label: 'Contracts' },
    { key: 'magazine.invoices', label: 'Invoices' },
  ] },
] as const;

export type MenuAccessKey = typeof MENU_ACCESS_GROUPS[number]['items'][number]['key'];
export const ALL_MENU_ACCESS_KEYS: MenuAccessKey[] = MENU_ACCESS_GROUPS.flatMap((group) => group.items.map((item) => item.key));

export const hasMenuAccess = (user: any, key: MenuAccessKey): boolean => {
  if (user?.roles?.includes('ROLE_ADMIN')) return true;
  if (!Array.isArray(user?.menu_items)) return true;
  return user.menu_items.includes(key);
};

export const hasExplicitMenuAccess = (user: any, key: MenuAccessKey): boolean =>
  Array.isArray(user?.menu_items) && user.menu_items.includes(key);

export const menuKeyForPath = (pathname: string): MenuAccessKey | null => {
  const mappings: [string, MenuAccessKey][] = [
    ['/magazine/publications', 'magazine.publications'], ['/magazine/issues', 'magazine.issues'],
    ['/magazine/inventory', 'magazine.inventory'], ['/magazine/proposals', 'magazine.proposals'],
    ['/magazine/reports', 'magazine.reports'], ['/contracts', 'magazine.contracts'],
    ['/invoices', 'magazine.invoices'], ['/events', 'events.events'], ['/maps', 'events.maps'],
    ['/applicants', 'events.exhibitors'], ['/products', 'events.products'], ['/orders', 'events.orders'],
  ];
  return mappings.find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1] || null;
};
